import { render, staticRenderFns } from "./SelectPlaneSidebarMenu.vue?vue&type=template&id=062f5cc6&scoped=true&"
import script from "./SelectPlaneSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./SelectPlaneSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./SelectPlaneSidebarMenu.vue?vue&type=style&index=0&id=062f5cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f5cc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062f5cc6')) {
      api.createRecord('062f5cc6', component.options)
    } else {
      api.reload('062f5cc6', component.options)
    }
    module.hot.accept("./SelectPlaneSidebarMenu.vue?vue&type=template&id=062f5cc6&scoped=true&", function () {
      api.rerender('062f5cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/SelectPlaneSidebarMenu.vue"
export default component.exports